import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle } from 'lucide-react';
import SEOHead from '../seo/SEOHead';
import { BreadcrumbSchema } from '../seo/SchemaMarkup';
import { PAGE_SEO, SITE_URL, SERVICES_SEO } from '../../seoConfig';

const Leistungen = () => {
  const services = Object.values(SERVICES_SEO);
  
  const breadcrumbs = [
    { name: "Start", url: SITE_URL },
    { name: "Leistungen", url: `${SITE_URL}/leistungen` }
  ];

  return (
    <>
      <SEOHead 
        title={PAGE_SEO.leistungen.title}
        description={PAGE_SEO.leistungen.description}
        canonical={PAGE_SEO.leistungen.canonical}
      />
      <BreadcrumbSchema items={breadcrumbs} />
      
      <div className="min-h-screen bg-gray-50">
        {/* Hero Section */}
        <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white py-24">
          <div 
            className="absolute inset-0 bg-cover bg-center opacity-20"
            style={{ backgroundImage: "url('/images/service-fassade.jpg')" }}
          ></div>
          <div className="container mx-auto px-6 relative z-10">
            {/* Breadcrumb */}
            <nav className="text-sm mb-8" aria-label="Breadcrumb">
              <ol className="flex items-center space-x-2">
                <li><Link to="/" className="text-gray-400 hover:text-white">Start</Link></li>
                <li className="text-gray-500">/</li>
                <li className="text-[#DC2626]">Leistungen</li>
              </ol>
            </nav>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
              Unsere <span className="text-[#DC2626]">Leistungen</span>
            </h1>
            <p className="text-xl text-gray-300 max-w-2xl">
              Professionelle Altbausanierung in Stuttgart und Region. Von der Fassade bis zum Dach – wir sanieren Ihr Gebäude fachgerecht.
            </p>
          </div>
        </section>

        {/* Services Grid */}
        <section className="py-20">
          <div className="container mx-auto px-6">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {services.map((service, index) => (
                <Link 
                  key={index}
                  to={`/leistungen/${service.slug}`}
                  className="group bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-500 hover:-translate-y-2"
                  data-testid={`service-card-${service.slug}`}
                >
                  <div className="relative h-56 overflow-hidden">
                    <img 
                      src={service.image}
                      alt={service.imageAlt}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  </div>
                  <div className="p-6">
                    <h2 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-[#DC2626] transition-colors">
                      {service.name}
                    </h2>
                    <p className="text-gray-600 mb-4 line-clamp-3">
                      {service.shortDescription}
                    </p>
                    <span className="inline-flex items-center text-[#DC2626] font-semibold group-hover:gap-3 gap-2 transition-all">
                      Mehr erfahren <ArrowRight className="w-4 h-4" />
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 bg-[#DC2626]">
          <div className="container mx-auto px-6 text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Kostenlose Erstberatung
            </h2>
            <p className="text-white/90 text-lg mb-8 max-w-2xl mx-auto">
              Vereinbaren Sie jetzt eine unverbindliche Besichtigung. Wir beraten Sie gerne zu Ihrem Sanierungsprojekt.
            </p>
            <Link 
              to="/kontakt"
              className="inline-flex items-center gap-2 bg-white text-[#DC2626] px-8 py-4 rounded-full font-bold hover:bg-gray-100 transition-colors shadow-xl"
              data-testid="cta-kontakt"
            >
              Jetzt anfragen <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
        </section>
      </div>
    </>
  );
};

export default Leistungen;
